import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { AttachMoneyOutlined } from '@mui/icons-material';
import { useCostEditor } from '../../../../hooks/useCostEditor';

/**
 * PartsCostEditor - Currency input for parts/materials cost.
 */
export const PartsCostEditor: React.FC = () => {
  const { costRecord, updateCostField } = useCostEditor();

  const handleChange = (value: string) => {
    const parsed = value === '' ? undefined : parseFloat(value);
    updateCostField({ partsCost: parsed });
  };

  return (
    <TextField
      label="Parts Cost"
      type="number"
      value={costRecord?.partsCost ?? ''}
      onChange={(e) => handleChange(e.target.value)}
      size="small"
      fullWidth
      placeholder="0.00"
      inputProps={{ min: 0, step: 0.01 }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <AttachMoneyOutlined sx={{ color: '#64748b', fontSize: 18 }} />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default PartsCostEditor;
